export var NAME = 'BvConfig';
export var PROP_NAME = '$bvConfig';
export var DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl'];


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/config.js
// module id = 270
// module chunks = 0